import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { VideoComponent } from './components/video/video.component';
import { AudioComponent } from './components/audio/audio.component';
import { IMComponent } from './components/im/im.component';
import { LayoutComponent } from './components/layout/layout.component';
import { HomeLayoutComponent } from './components/layout/homelayout.component';
import { CommsService } from './services/comms.service';
import { AuthGuard } from './guards/auth.guard';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserModalComponent } from './components/shared/browser-modal.component';
import { DeviceSetupComponent } from './components/device-setup/device-setup.component';
import { DeviceLayoutComponent } from './components/layout/devicelayout.component';
import { Step0InitialComponent } from './components/device-setup/step-0-initial/step-0-initial.component';
import { Step1VideoComponent } from './components/device-setup/step-1-video/step-1-video.component';
import { Step2MicComponent } from './components/device-setup/step-2-mic/step-2-mic.component';
import { Step3SpeakersComponent } from './components/device-setup/step-3-speakers/step-3-speakers.component';
import { Step4SpeedComponent } from './components/device-setup/step-4-speed/step-4-speed.component';
import { Step5CompleteComponent } from './components/device-setup/step-5-complete/step-5-complete.component';

@NgModule({
    declarations: [
      AppComponent,
      HomeComponent,
      VideoComponent,
      AudioComponent,
      IMComponent,
      LayoutComponent,
      HomeLayoutComponent,
      BrowserModalComponent,
      DeviceSetupComponent,
    DeviceLayoutComponent,
    Step0InitialComponent,
    Step1VideoComponent,
    Step2MicComponent,
    Step3SpeakersComponent,
    Step4SpeedComponent,
    Step5CompleteComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot([
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: '',
        component: HomeLayoutComponent,
        children: [
            { path: 'home', component: HomeComponent }
        ]
    },
    {
        path: '',
        component: HomeLayoutComponent,
        children: [
            { path: 'home/:sid/:p', component: HomeComponent }
        ]
    },
    {
        path: '',
        component: LayoutComponent,
        children: [
            { path: 'video', component: VideoComponent, canActivate: [AuthGuard] },
            { path: 'audio', component: AudioComponent, canActivate: [AuthGuard] },
            { path: 'im', component: IMComponent, canActivate: [AuthGuard] }
        ]
    },
    {
        path: '',
        component: DeviceLayoutComponent,
        children: [
            { path: 'device-setup/:t', component: DeviceSetupComponent }
        ]
    }
], { relativeLinkResolution: 'legacy' })
    ],
    providers: [
        { provide: 'BASE_URL', useFactory: getBaseUrl },
        CommsService,
        AuthGuard
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}

export function getBaseUrl() {
        return document.getElementsByTagName('base')[0].href;
}
